import { FC } from 'react';
import { Textarea } from 'components/UI/V3/Forms/Textarea/Textarea';
import styles from './DescriptionSection.module.scss';

interface DescriptionSectionProps {
    className?: string;
    value: string;
    error: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const DescriptionSection: FC<DescriptionSectionProps> = ({ value, error, onChange, className }) => {
    return (
        <Textarea
            maxLength={400}
            label="Write a Short Description"
            error={error}
            value={value}
            onChange={onChange}
            className={className}
        />
    );
};
